var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.46 20.46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.46 18.69-5.25-5.25a8.369 8.369 0 0 0 1.66-5.01C16.87 3.78 13.09 0 8.43 0a8.431 8.431 0 0 0 0 16.86c1.88 0 3.61-.62 5.01-1.66l5.25 5.25 1.77-1.76zM8.43 14.05c-3.1 0-5.62-2.51-5.62-5.62 0-3.1 2.52-5.62 5.62-5.62s5.61 2.51 5.61 5.62c.01 3.11-2.5 5.62-5.61 5.62z"
  })));
};
export default SvgSearch;